import Ranking from "./Ranking";
export default Ranking;
